import { mapGetters } from 'vuex';

export const scrollyMixin = {
		data() {
		return {
			sectionsData: [], // {prefix: '', parenthesisTextWidth: 0, sectionId: ''}
			inDepthsData: [],
			mobileActiveSections: {},
		}
	},
	computed: {
		...mapGetters(['isMobile']),
		currentPrefix() {
			this.sectionsData.length ? this.sectionsData.find(el => el.sectionId == this.currSection.id).prefix : ''
		}
	},
	methods: {
		mountSectionsAnimations() {
			this.sections.forEach(s => {
				let prefix = `#${s.id}`
				// let prefix = `[data-scrolly-id="${this.scrolly.id}"] #${s.id}`
				this.sectionsData.push({
					prefix: prefix,
					parenthesisTextWidth: this.setParenthesisItem(prefix),
					sectionId: s.id
				})
			})
			this.setIndepthsData();
			this.resetAllIndepths();
			this.mountCustomAnimations();
		},
		setIndepthsData() {
			let inDepths = Array.from(document.querySelectorAll('.scroll-content-section-button'))
			inDepths.forEach(el => {
				let section = Array.from(document.querySelectorAll(".scroll-container > section[id^='s']")).filter(s => s.contains(el))[0]
				let prefix = '#'+section.getAttribute('id') + ' .' + Array.from(el.classList).join('.')

				this.inDepthsData.push({
					prefix: prefix,
					parenthesisTextWidth: this.setParenthesisItem(prefix),
					sectionId: section.getAttribute('id')
				})
			})
		},
		mountMobileAnimations(cbs) {
			let arr = Array.from(document.querySelectorAll('.scroll-container section'))
			arr.forEach((sec, i) => {
				if(i > 0 && i < arr.length-1) {
					if(sec.querySelector('.scrolly-artifact-container')) sec.querySelector('.scrolly-artifact-container').style.opacity = 1

					if(sec.querySelector('.artifact-comic')) sec.querySelector('.artifact-comic').style.opacity = 0;
					if(sec.querySelector('.scroll-content-text')) {
						// console.log(sec.querySelector('.scroll-content-text'))
						sec.querySelector('.scroll-content-text').style.opacity = 1;
					}
				}
					// sec.querySelector('.scroll-content-section-button').style.opacity = 1; }
			})
			cbs.forEach(el => el())
		},
		mountSectionsObservers() {
			if ('IntersectionObserver' in window) {
				let observerSections = new IntersectionObserver(entries => {
					entries.map((entry) => {
						const id = entry.target.id;
						if (entry.isIntersecting) {
							this.mobileActiveSections[id] = entry.intersectionRatio;
						} else {
							delete this.mobileActiveSections[id];
						}

						if (!this.showScrolly) return;

						const entries = Object.entries(this.mobileActiveSections).sort((a, b) => a[1] - b[1]);
						if (!entries.length) return;
						const sectionId = entries[0][0];

						let query = this.$route.query;
						if ('object' !== typeof query) query = {};
						if (sectionId !== query.sectionId) {
							this.$router.replace({ query: { ...query, sectionId } });
						}
					});
				}, { threshold: 0.4 });
				document.querySelectorAll('.scroll-container > section').forEach(item => {
					observerSections.observe(item);	
				});
			} else {
				// simply polyfill immediately renders everything visible
				// (needed for iOS v11, …?)
				window.IntersectionObserver = class IntersectionObserver {
					constructor(callback) {
						this.callback = callback;
					}

					observe(target) {
						if (target) this.callback([{ isIntersecting: true, target }]);
					}
				};
			}

			let targetScrollyText = '.scroll-content-text'
			let options = {
				rootMargin: `0px 0px ${-window.innerHeight/8}px 0px`,
				threshold: 0
			}

			let observer = new IntersectionObserver(entries => {
				entries.map((entry) => {
					if (entry.isIntersecting) {
						let tg = entry.target
						window.requestAnimationFrame(() => {
							if(!tg.classList.contains('visible')) tg.classList.add('visible')
						})
					}
				});
			}, options);
			document.querySelectorAll(targetScrollyText).forEach(item => {
				observer.observe(item);	
			});

			let observerReperti = new IntersectionObserver(entries => {
				entries.map((entry) => {
					if (entry.isIntersecting) {
						window.requestAnimationFrame(() => {
							entry.target.classList.add('visible')
						})
					}
				});
			}, { threshold: 0.15 });
			document.querySelectorAll('.mobile-anim').forEach(item => observer.observe(item));	

			let targetScrollyCuriosity = '.scrolly-content-curiosity'

			let observerCuriosity = new IntersectionObserver(entries => {
				entries.map((entry) => {
					if (entry.isIntersecting) {
						// console.log('curiosity')
						let tg = entry.target
						let scale = parseFloat(tg.getAttribute('data-new-scale'))
						let left = parseFloat(tg.getAttribute('data-left'))
						if(!tg.classList.contains('visible')) {
							// console.log('here')
							window.requestAnimationFrame(() => {
								tg.style.transform = `translate(0, 0) scale(${scale}) rotate(-5deg)`
							})
							// tg.classList.add('visible')
						}
					}
				});
			}, options);
			document.querySelectorAll(targetScrollyCuriosity).forEach(item => {
				// console.log(item)
				observerCuriosity.observe(item);	
			});
		},
		getPrefixFromSectionId(sectionId) {
			return this.sectionsData.find(el => el.sectionId == sectionId).prefix
		},
		setParenthesisItem(prefix) {
			if(!document.querySelector(`${prefix} .section-button-text`)) return 0

			let parenthesisTextWidth = document.querySelector(`${prefix} .section-button-text`).getBoundingClientRect().width
			return parenthesisTextWidth;
		},
		resetAllIndepths() {
			this.inDepthsData.forEach(el => {
				document.querySelector(`${el.prefix} .section-button-text`).style.width = 0+'px';
			})
		},
		defaultInDepthButtonAnimation(t, animationPrefix, time) {
			if(document.querySelector(`${animationPrefix} .scroll-content-section-button`)) {
				let parenthesisTextWidth = this.sectionsData.find(el => el.prefix == animationPrefix).parenthesisTextWidth
				document.querySelector(`${animationPrefix} .section-button-text`).style.width = 0+'px';
				t.to(`${animationPrefix} .scroll-content-section-button`, {opacity: 1, duration: 0.7}, time)

				t.to(`${animationPrefix} .section-button-text`, {width: parenthesisTextWidth + 'px', duration: 0.7}, time)
				t.to(`${animationPrefix} .section-button-text`, {opacity: 1}, time)
			}
		},
		defaultArtifactInfoAnimation(t, animationPrefix, time) {
			if (document.querySelector(`${animationPrefix} .scrolly-artifact-container`)) {
				t.addLabel('artifact')
				let artifactTextWidth = document.querySelector(`${animationPrefix} .scrolly-artifact-container .scrolly-artifact-comic-text-content`).getBoundingClientRect().width;
				let singlePadding = parseInt(window.getComputedStyle(document.querySelector(`${animationPrefix} .scrolly-artifact-comic-text`), null).getPropertyValue('padding-right').replace('px', ''));
				t.to(`${animationPrefix} .scrolly-artifact-container .scrolly-artifact-comic-text`, {width: `calc(${artifactTextWidth}px + (${singlePadding}px * 2))`, opacity: 1, duration: 0.7}, time)
				t.to(`${animationPrefix} .scrolly-artifact-container .base-button-rounded`, {opacity: 1}, time)
			}
		},
		defaultContentAnimation(t, idSection, specificTime, animateArtifactInfo=true) {
			let animationPrefix = this.getPrefixFromSectionId(idSection)
			// console.log('animation prefix', animationPrefix)
			let position = document.querySelector(`${animationPrefix} .scroll-content-section`).classList.contains('left') ? 'left' : 'right'
			let time = specificTime ? specificTime : 0
			t.to(`${animationPrefix} .scroll-content-section .scroll-content-text`, {transform: `translate(${position == 'right' ? 'calc(var(--scrolly-w) - var(--section-right-margin) - 100%)' : 'var(--section-left-margin)'}, -50%`, opacity: 1, duration: 0.7}, time)
			this.defaultInDepthButtonAnimation(t, animationPrefix, time);
			if(animateArtifactInfo) this.defaultArtifactInfoAnimation(t, animationPrefix, time);
		},

		defaultContentAnimationElements(t, idSection, contentSectionEl=null, inDepthEl=null, artifactButtonEl=null, time=0) {
			// let animationPrefix = this.getPrefixFromSectionId(idSection)
			// console.log('animation prefix', animationPrefix)
			if(contentSectionEl) {
				// console.log('contentSectionEl', contentSectionEl)
				let position = document.querySelector(contentSectionEl).classList.contains('left') ? 'left' : 'right'
				t.to(`${contentSectionEl} .scroll-content-text`, {transform: `translate(${position == 'right' ? 'calc(var(--scrolly-w) - var(--section-right-margin) - 100%)' : 'var(--section-left-margin)'}, -50%`, opacity: 1, duration: 0.7}, time)
			}

			if(inDepthEl) {
				let parenthesisTextWidth = this.inDepthsData.find(el => el.prefix.indexOf(inDepthEl) > -1).parenthesisTextWidth
				// console.log(inDepthEl, parenthesisTextWidth)
				// let parenthesisTextWidth = this.sectionsData.find(el => el.prefix == animationPrefix).parenthesisTextWidth
				document.querySelector(`${inDepthEl} .section-button-text`).style.width = 0+'px';
				t.to(inDepthEl, {opacity: 1, duration: 0.7}, time)

				t.to(`${inDepthEl} .section-button-text`, {width: parenthesisTextWidth + 'px', duration: 0.7}, time)
				t.to(`${inDepthEl} .section-button-text`, {opacity: 1})
			}
			if(artifactButtonEl) {
				// console.log('artifact button animation')
				let artifactTextWidth = document.querySelector(`${artifactButtonEl} .scrolly-artifact-comic-text-content`).getBoundingClientRect().width;
				let singlePadding = window.getComputedStyle(document.querySelector(`${artifactButtonEl} .scrolly-artifact-comic-text`), null).getPropertyValue('padding-right')
				t.to(`${artifactButtonEl} .scrolly-artifact-comic-text`, {width: `calc(${artifactTextWidth}px + (${singlePadding} * 2))`, opacity: 1, duration: 0.7}, time)
				t.to(`${artifactButtonEl} .base-button-rounded`, {opacity: 1}, time)
			}
		},

		remarkablePointAnimation(t, idSection, specificTime) {
			let animationPrefix = this.getPrefixFromSectionId(idSection)
			let time = specificTime ? specificTime : 0
			if(this.scrolly.sections.find(el => el.id == idSection).remarkablePoints) {
				t.to(animationPrefix+' .remarkable-point-cont', {opacity: 1}, time)
			}
		},

		curiosityAnimation(t, sectionId, closeBtn, specificTime, selector='') {
			// console.log('sectionId', sectionId)
			let animationPrefix = this.getPrefixFromSectionId(sectionId)
			let time = specificTime ? specificTime : 0
			let actionBtn = closeBtn ? {width: 0, duration: 0.5} : {opacity: 0, duration: 0.5}
			t.addLabel('curiosity', time)
			t.to(`${animationPrefix} .scrolly-content-curiosity${selector}`, {transform: 'translate(10vw, calc(50vh - 50%)) rotate(-10deg)', duration: 0.5}, 'curiosity')
			t.to(`${animationPrefix} .scroll-content-text`, {opacity: 0, duration: 0.5}, 'curiosity')
			if(document.querySelector(`${animationPrefix} .scroll-content-section-button`)) t.to(`${animationPrefix} .scroll-content-section-button`, actionBtn, 'curiosity')
				
			t.to(`${animationPrefix} .scrolly-artifact-comic-text`, {opacity: 0, duration: 0.5}, 'curiosity')
		},

		curiosityAnimationElements(t, curiositEl=null, contentTextEL=null, inDepthItemEl=null, artifactEl=null, time=0) {
			// let actionBtn = closeBtn ? {width: 0, duration: 0.5} : {opacity: 0, duration: 0.5}
			if(curiositEl) {
				t.to(curiositEl, {transform: 'translate(10vw, calc(50vh - 50%)) rotate(-10deg)', duration: 0.5}, time)
			}
			if(contentTextEL) {
				t.to(contentTextEL, {opacity: 0, duration: 0.5}, time)
			}
			if(inDepthItemEl) {
				t.to(inDepthItemEl, {opacity: 0, duration: 0.5}, time)
			}
			if(artifactEl) {
				t.to(artifactEl, {opacity: 0, duration: 0.5}, time)
			}
		},
		manageScrollInhibition(t) {
			t.eventCallback('onComplete', () => {
				this.resetInhibitScroll()	
			})
			t.eventCallback('onReverseComplete', () => {
				this.resetInhibitScroll()	
			})

			
			// t.eventCallback('onLeav', this.resetInhibitScroll)
		},
	}
}
